import React from 'react'

export default function About(){

 return ( 
   <div className='about-page'>
   <div className='about-section'>
     <h1>About Kaif Arslan</h1>
     <p>Hey there! I'm Kaif Arslan</p>
     <p>A Frontend Developer with expertise in React, JavaScript, HTML & CSS. I also have experience in Python and C programming. I've honed my skills in crafting responsive web designs that deliver exceptional user experiences. Constantly learning and staying updated with the latest trends, I thrived in collaborative environments and believed effective communication was key to success. Let's create something incredible together!
</p>
     <p>
      As you might already came to know that this is a project to show my frontend skills not the a real shopping site. This project uses the following technologies
     </p>
     <ul>
       <li>React</li>
       <li>React Router</li>
       <li>HTML & CSS</li>
     </ul>
     <p>Github link of this repository 👉 <a href='https://github.com/KaifArslan/shopping-site.git'><i class="fab fa-github aboutGit"></i></a></p>
     <hr />

   </div>
   </div>
 
 )
}